<template>
  <BaseDialog
    v-model="showDialog"
    title="Avvik"
    subtitle="Legg til avvik"
    dialogIcon="mdi-alert-outline"
    btnActionName="Lagre"
    @action="save"
  >
    <template v-slot>
      <v-form ref="form" v-model="valid">
        <v-text-field v-model="data.title" filled label="Navn"></v-text-field>
        <v-textarea
          v-model="data.description"
          filled
          label="Beskrivelse"
        ></v-textarea>
      </v-form>
      <v-btn
        v-if="data.attachments && data.attachments.length > 0"
        class="mb-2"
        small
        color="primary"
        @click="$refs.dropzone.addAttachment()"
      >
        Legg til fil
      </v-btn>
      <FileDropzone ref="dropzone" v-model="data.attachments" :close="false" />
    </template>
  </BaseDialog>
</template>

<script lang="ts">
import Vue from "vue";
import BaseDialog from "@/components/shared/dialog/BaseDialog.vue";
import FileDropzone from "@/components/shared/attachments/FileDropzone.vue";

export default Vue.extend({
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    data: {
      type: Object,
    },
  },
  data() {
    return {
      valid: false,
    };
  },
  methods: {
    async save() {
      const isValid = (this as any).$refs?.form?.validate();
      if (isValid) {
        this.$emit("save", this.data);
      }
    },
  },

  computed: {
    showDialog: {
      get(): boolean {
        return this.value;
      },
      set(value: boolean) {
        this.$emit("input", value);
      },
    },
  },
  components: {
    BaseDialog,
    FileDropzone,
  },
});
</script>
